import { Controller } from "@hotwired/stimulus"

// Flash toast: dismissible, and gone on its own after a while.
export default class extends Controller {
  static values = { timeout: { type: Number, default: 8000 } }

  connect() {
    this.timer = setTimeout(() => this.dismiss(), this.timeoutValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  dismiss(event) {
    clearTimeout(this.timer)
    const alert = event?.target?.closest(".alert")
    if (alert && this.element.querySelectorAll(".alert").length > 1) {
      alert.remove()
    } else {
      this.element.remove()
    }
  }
}
